$('.js-cabinet-order-remove').on('click', (e) => {
	$(e.currentTarget).closest('tr').remove();
});